
import { addressApi, AddressApiResponse, AddressProposition } from '@/api/address'
import { cloneDeep, isEqual } from 'lodash'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AddressPropositions',
  components: {

  },
  props: {
    search: { type: String, default: '' },
    limit: { type: Number, default: 5 },
    postcode: { type: String, default: '' },
    columnNumber: { type: Number, default: 1 },
  },
  data: () => ({
    proposition: undefined as AddressApiResponse | undefined,
    lock: false,
    filterKey: '',
  }),
  methods: {
    selectAddress(address: AddressProposition) {
      this.lock = true
      this.$emit('selectAddress', address)
    },
    async searchAddress() {
      if (this.search?.length > 3) {
        this.proposition = await addressApi.findAddress(this.search, this.postcode, this.limit)
      }
    },
  },
  computed: {
    getColNumber(): number {
      if (Number(this.columnNumber) && Number.isInteger(this.columnNumber) && this.columnNumber >= 1 && this.columnNumber <= 4) {
        return this.columnNumber
      } else {
        return 1
      }
    },
    orderedProposition(): AddressProposition[] {
      return cloneDeep(this.proposition?.features)?.sort((a, b) => b.properties.score - a.properties.score) || []
    },
  },
  watch: {
    'search': {
      handler(val, oldVal) {
        if (!isEqual(val, oldVal) && !this.lock) {
          this.searchAddress()
        }
        this.lock = false
      },
    },
  },
})
